import React, { useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Tooltip } from "@mui/material";
import PropTypes from "prop-types";
const CodeComponent = ({ businessID, apiKey }) => {
  const codeToCopy = `
    <script is:inline src="${process.env.REACT_APP_SDK_BASEURL}/sdk.js"></script>
    <script data-args="${apiKey}">
        window.SDKManager.setBusinessId("${businessID}");
    </script>`;

  const [copied, setCopied] = useState(false);

  const handleCopyClick = () => {
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1500); // Reset the copied state after 1.5 seconds
  };

  const handleDownloadClick = () => {
    const element = document.createElement("a");
    const file = new Blob([codeToCopy], { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download = "widget_code.txt";
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  };

  return (
    <div className="mt-63px w-full max-w-242">
      <div className="flex items-center justify-between">
        <p className="font-MontserratSemiBold text-ft19-23 text-black-20 md:text-ft22-26.82-0.4">
          Widget Code
        </p>
        <div className="flex items-center gap-4.5">
          <Tooltip open={copied} placement="top-end" title="Copied!">
            <div>
              <CopyToClipboard text={codeToCopy} onCopy={handleCopyClick}>
                <div className="relative flex cursor-pointer items-center gap-2 font-MontserratRegular text-ft15-18.29-0.3">
                  <img src="/images/copy-icon.svg" alt="copy"></img>
                  Copy
                </div>
              </CopyToClipboard>
            </div>
          </Tooltip>
          <div
            className="flex cursor-pointer items-center gap-2 font-MontserratRegular text-ft15-18.29-0.3"
            onClick={handleDownloadClick}
          >
            <img
              className="size-4"
              src="/images/download-icon.svg"
              alt="download"
            ></img>
            Download
          </div>
        </div>
      </div>
      <div className="mt-3.5 break-all rounded bg-purple-F6E6FB p-4 md:pb-41px md:pl-9 md:pt-5">
        <pre className="max-w-175 overflow-x-auto whitespace-pre-wrap">
          <code className="font-MontserratMedium text-ft16-24">
            {codeToCopy}
          </code>
        </pre>
      </div>
    </div>
  );
};
CodeComponent.propTypes = {
  businessID: PropTypes.string.isRequired,
  apiKey: PropTypes.string.isRequired
};
export default CodeComponent;
